<template>
    <div class="user_index" v-loading="loading">
        <div class="user_index_box">
            <div class="title_box">
                <img src="../../assets/img/login/Frame.png" alt="">
                <span class="span1">首页</span> > <span class="span2" @click="$router.push('/user_grzx')">个人中心</span>
                <span class="span2" v-if="path_title">> {{ path_title }}</span>
            </div>
            <div class="index_flex">
                <div class="lefts">
                    <div class="item1" v-for="(item1, index1) in path_list" :key="index1">
                        <div class="item_title">{{ item1.title }}</div>
                        <div class="item_list">
                            <div class="item_item" v-for="(item2, index2) in item1.list" :key="index2"
                                :class="{ 'item_item_ac': path_ac == item2.path }" @click="handle_path(item2)">
                                <div class="item_img">
                                    <img :src="item2.images1" alt="" class="img1">
                                    <img :src="item2.images2" alt="" class="img2">
                                </div>
                                <div class="item_name">{{ item2.title }}</div>
                                <div class="item_bg">
                                </div>
                                <div class="item_borders"></div>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="rights">
                    <router-view key="user_index"></router-view>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            path_title: '',
            path_ac: '1',
            path_list: [
                {
                    title: '订单中心',
                    list: [
                        {
                            title: '我的订单',
                            images1: require('../../assets/img/user_info/user_index/wddd1.png'),
                            images2: require('../../assets/img/user_info/user_index/wddd2.png'),
                            path: '/user_order',//
                        },
                        {
                            title: '我的点评',
                            images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                            images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                            path: '/user_dp',//
                        },
                        {
                            title: '我的委托',
                            images1: require('../../assets/img/user_info/user_index/wdwt1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdwt2.png'),
                            path: '/user_wt',//
                        }
                    ],
                },

                {
                    title: '我的服务',
                    list: [

                        {
                            title: '点评服务',
                            images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                            images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                            path: '/user_dpfw',//
                        },
                        {
                            title: '委托服务',
                            images1: require('../../assets/img/user_info/user_index/wdwt1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdwt2.png'),
                            path: '/user_wtfw',//
                        }
                    ],
                },
                {
                    title: '消息中心',
                    list: [
                        {
                            title: '我的消息',
                            images1: require('../../assets/img/user_info/user_index/wdxx1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdxx2.png'),
                            path: '/user_xx',//
                        },
                        {
                            title: '我的咨询',
                            images1: require('../../assets/img/user_info/user_index/wdzx1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdzx2.png'),
                            path: '/user_zx',//
                        }
                    ],
                },
                {
                    title: '账户资金',
                    list: [
                        {
                            title: '我的积分',
                            images1: require('../../assets/img/user_info/user_index/wdjf1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdjf2.png'),
                            path: '/user_jf',//
                        },
                        {
                            title: '积分商城',
                            images1: require('../../assets/img/user_info/user_index/jfsc1.png'),
                            images2: require('../../assets/img/user_info/user_index/jfsc2.png'),
                            path: '/shop',//
                        },
                        {
                            title: '我的奖励',
                            images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                            path: '/user_jl',//
                        },
                        {
                            title: '抽奖活动',
                            images1: require('../../assets/img/user_info/user_index/cjhd1.png'),
                            images2: require('../../assets/img/user_info/user_index/cjhd2.png'),
                            path: '/user_cjhd',//
                        }
                    ],
                },
                {
                    title: '财务',
                    list: [
                        {
                            title: '财务管理',
                            images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                            images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                            path: '/user_cwgl',//
                        }
                    ]
                },
                {
                    title: '用户',
                    list: [
                        {
                            title: '个人资料',
                            images1: require('../../assets/img/user_info/user_index/grzl1.png'),
                            images2: require('../../assets/img/user_info/user_index/grzl2.png'),
                            path: '/user_zl',//
                        },
                        {
                            title: '修改密码',
                            images1: require('../../assets/img/user_info/user_index/xgmm1.png'),
                            images2: require('../../assets/img/user_info/user_index/xgmm2.png'),
                            path: '/user_mm',//
                        },
                        {
                            title: '发票管理',
                            images1: require('../../assets/img/user_info/user_index/fpgl1.png'),
                            images2: require('../../assets/img/user_info/user_index/fpgl2.png'),
                            path: '/user_gl',//
                        }
                    ],
                },
                {
                    title: '其他',
                    list: [
                        {
                            title: '帮助中心',
                            images1: require('../../assets/img/user_info/user_index/bzzx1.png'),
                            images2: require('../../assets/img/user_info/user_index/bzzx2.png'),
                            path: '/user_bzzx',//
                        }
                    ],
                }
            ],
        }
    },
    computed: {

    },
    watch: {
        $route: {
            handler(newVal, oldVal) {
                console.log(newVal)
                this.path_ac = '/' + newVal.path.split('/')[1]
                if (newVal.meta.title != '个人中心') {

                    this.path_title = newVal.meta.title
                } else {
                    this.path_title = ''
                }

            },
            immediate: true,
            deep: true
        },

        // path_ac
    },
    created() {
        this.get_user()
    },
    methods: {
        handle_path(item) {
            this.$router.push({
                path: item.path
            })
        },
        get_user() {
            this.$api("getUserInfo", {

            }, "get").then((res) => {
                this.loading = false
                console.log('用户信息', res)
                if (res.code == 1) {
                    if (res.data.type == 2 || res.data.type == 3) {
                        // this.grzs_show=2
                        this.path_list = [
                            {
                                title: '订单中心',
                                list: [
                                    {
                                        title: '我的订单',
                                        images1: require('../../assets/img/user_info/user_index/wddd1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddd2.png'),
                                        path: '/user_order',//
                                    },
                                    {
                                        title: '我的点评',
                                        images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                                        path: '/user_dp',//
                                    },
                                    {
                                        title: '我的委托',
                                        images1: require('../../assets/img/user_info/user_index/wdwt1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdwt2.png'),
                                        path: '/user_wt',//
                                    }
                                ],
                            },

                            {
                                title: '我的服务',
                                list: [

                                    {
                                        title: '点评服务',
                                        images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                                        path: '/user_dpfw',//
                                    },
                                    {
                                        title: '委托服务',
                                        images1: require('../../assets/img/user_info/user_index/wdwt1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdwt2.png'),
                                        path: '/user_wtfw',//
                                    }
                                ],
                            },
                            {
                                title: '消息中心',
                                list: [
                                    {
                                        title: '我的消息',
                                        images1: require('../../assets/img/user_info/user_index/wdxx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdxx2.png'),
                                        path: '/user_xx',//
                                    },
                                    {
                                        title: '我的咨询',
                                        images1: require('../../assets/img/user_info/user_index/wdzx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdzx2.png'),
                                        path: '/user_zx',//
                                    }
                                ],
                            },
                            {
                                title: '账户资金',
                                list: [
                                    {
                                        title: '我的积分',
                                        images1: require('../../assets/img/user_info/user_index/wdjf1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdjf2.png'),
                                        path: '/user_jf',//
                                    },
                                    {
                                        title: '积分商城',
                                        images1: require('../../assets/img/user_info/user_index/jfsc1.png'),
                                        images2: require('../../assets/img/user_info/user_index/jfsc2.png'),
                                        path: '/shop',//
                                    },
                                    {
                                        title: '我的奖励',
                                        images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                                        path: '/user_jl',//
                                    },
                                    {
                                        title: '抽奖活动',
                                        images1: require('../../assets/img/user_info/user_index/cjhd1.png'),
                                        images2: require('../../assets/img/user_info/user_index/cjhd2.png'),
                                        path: '/user_cjhd',//
                                    }
                                ],
                            },
                            {
                                title: '财务',
                                list: [
                                    {
                                        title: '财务管理',
                                        images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                                        path: '/user_cwgl',//
                                    }
                                ]
                            },
                            {
                                title: '用户',
                                list: [
                                    {
                                        title: '个人资料',
                                        images1: require('../../assets/img/user_info/user_index/grzl1.png'),
                                        images2: require('../../assets/img/user_info/user_index/grzl2.png'),
                                        path: '/user_zl',//
                                    },
                                    {
                                        title: '修改密码',
                                        images1: require('../../assets/img/user_info/user_index/xgmm1.png'),
                                        images2: require('../../assets/img/user_info/user_index/xgmm2.png'),
                                        path: '/user_mm',//
                                    },
                                    {
                                        title: '发票管理',
                                        images1: require('../../assets/img/user_info/user_index/fpgl1.png'),
                                        images2: require('../../assets/img/user_info/user_index/fpgl2.png'),
                                        path: '/user_gl',//
                                    }
                                ],
                            },
                            {
                                title: '其他',
                                list: [
                                    {
                                        title: '帮助中心',
                                        images1: require('../../assets/img/user_info/user_index/bzzx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/bzzx2.png'),
                                        path: '/user_bzzx',//
                                    }
                                ],
                            }
                        ]
                    }else if(res.data.comment_level){
                        this.path_list = [
                            {
                                title: '订单中心',
                                list: [
                                    {
                                        title: '我的订单',
                                        images1: require('../../assets/img/user_info/user_index/wddd1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddd2.png'),
                                        path: '/user_order',//
                                    },
                                    {
                                        title: '我的点评',
                                        images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                                        path: '/user_dp',//
                                    },
                                    {
                                        title: '我的委托',
                                        images1: require('../../assets/img/user_info/user_index/wdwt1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdwt2.png'),
                                        path: '/user_wt',//
                                    }
                                ],
                            },

                            {
                                title: '我的服务',
                                list: [

                                    {
                                        title: '点评服务',
                                        images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                                        path: '/user_dpfw',//
                                    },
                                ],
                            },
                            {
                                title: '消息中心',
                                list: [
                                    {
                                        title: '我的消息',
                                        images1: require('../../assets/img/user_info/user_index/wdxx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdxx2.png'),
                                        path: '/user_xx',//
                                    },
                                    {
                                        title: '我的咨询',
                                        images1: require('../../assets/img/user_info/user_index/wdzx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdzx2.png'),
                                        path: '/user_zx',//
                                    }
                                ],
                            },
                            {
                                title: '账户资金',
                                list: [
                                    {
                                        title: '我的积分',
                                        images1: require('../../assets/img/user_info/user_index/wdjf1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdjf2.png'),
                                        path: '/user_jf',//
                                    },
                                    {
                                        title: '积分商城',
                                        images1: require('../../assets/img/user_info/user_index/jfsc1.png'),
                                        images2: require('../../assets/img/user_info/user_index/jfsc2.png'),
                                        path: '/shop',//
                                    },
                                    {
                                        title: '我的奖励',
                                        images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                                        path: '/user_jl',//
                                    },
                                    {
                                        title: '抽奖活动',
                                        images1: require('../../assets/img/user_info/user_index/cjhd1.png'),
                                        images2: require('../../assets/img/user_info/user_index/cjhd2.png'),
                                        path: '/user_cjhd',//
                                    }
                                ],
                            },
                            {
                                title: '财务',
                                list: [
                                    {
                                        title: '财务管理',
                                        images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                                        path: '/user_cwgl',//
                                    }
                                ]
                            },
                            {
                                title: '用户',
                                list: [
                                    {
                                        title: '个人资料',
                                        images1: require('../../assets/img/user_info/user_index/grzl1.png'),
                                        images2: require('../../assets/img/user_info/user_index/grzl2.png'),
                                        path: '/user_zl',//
                                    },
                                    {
                                        title: '修改密码',
                                        images1: require('../../assets/img/user_info/user_index/xgmm1.png'),
                                        images2: require('../../assets/img/user_info/user_index/xgmm2.png'),
                                        path: '/user_mm',//
                                    },
                                    {
                                        title: '发票管理',
                                        images1: require('../../assets/img/user_info/user_index/fpgl1.png'),
                                        images2: require('../../assets/img/user_info/user_index/fpgl2.png'),
                                        path: '/user_gl',//
                                    }
                                ],
                            },
                            {
                                title: '其他',
                                list: [
                                    {
                                        title: '帮助中心',
                                        images1: require('../../assets/img/user_info/user_index/bzzx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/bzzx2.png'),
                                        path: '/user_bzzx',//
                                    }
                                ],
                            }
                        ]
                    } else {
                        // this.grzs_show=1
                        this.path_list = [
                            {
                                title: '订单中心',
                                list: [
                                    {
                                        title: '我的订单',
                                        images1: require('../../assets/img/user_info/user_index/wddd1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddd2.png'),
                                        path: '/user_order',//
                                    },
                                    {
                                        title: '我的点评',
                                        images1: require('../../assets/img/user_info/user_index/wddp1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wddp2.png'),
                                        path: '/user_dp',//
                                    },
                                    {
                                        title: '我的委托',
                                        images1: require('../../assets/img/user_info/user_index/wdwt1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdwt2.png'),
                                        path: '/user_wt',//
                                    }
                                ],
                            },


                            {
                                title: '消息中心',
                                list: [
                                    {
                                        title: '我的消息',
                                        images1: require('../../assets/img/user_info/user_index/wdxx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdxx2.png'),
                                        path: '/user_xx',//
                                    },
                                    {
                                        title: '我的咨询',
                                        images1: require('../../assets/img/user_info/user_index/wdzx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdzx2.png'),
                                        path: '/user_zx',//
                                    }
                                ],
                            },
                            {
                                title: '账户资金',
                                list: [
                                    {
                                        title: '我的积分',
                                        images1: require('../../assets/img/user_info/user_index/wdjf1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdjf2.png'),
                                        path: '/user_jf',//
                                    },
                                    {
                                        title: '积分商城',
                                        images1: require('../../assets/img/user_info/user_index/jfsc1.png'),
                                        images2: require('../../assets/img/user_info/user_index/jfsc2.png'),
                                        path: '/shop',//
                                    },
                                    {
                                        title: '我的奖励',
                                        images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                                        path: '/user_jl',//
                                    },
                                    {
                                        title: '抽奖活动',
                                        images1: require('../../assets/img/user_info/user_index/cjhd1.png'),
                                        images2: require('../../assets/img/user_info/user_index/cjhd2.png'),
                                        path: '/user_cjhd',//
                                    }
                                ],
                            },
                            {
                                title: '财务',
                                list: [
                                    {
                                        title: '财务管理',
                                        images1: require('../../assets/img/user_info/user_index/wdyj1.png'),
                                        images2: require('../../assets/img/user_info/user_index/wdyj2.png'),
                                        path: '/user_cwgl',//
                                    }
                                ]
                            },
                            {
                                title: '用户',
                                list: [
                                    {
                                        title: '个人资料',
                                        images1: require('../../assets/img/user_info/user_index/grzl1.png'),
                                        images2: require('../../assets/img/user_info/user_index/grzl2.png'),
                                        path: '/user_zl',//
                                    },
                                    {
                                        title: '修改密码',
                                        images1: require('../../assets/img/user_info/user_index/xgmm1.png'),
                                        images2: require('../../assets/img/user_info/user_index/xgmm2.png'),
                                        path: '/user_mm',//
                                    },
                                    {
                                        title: '发票管理',
                                        images1: require('../../assets/img/user_info/user_index/fpgl1.png'),
                                        images2: require('../../assets/img/user_info/user_index/fpgl2.png'),
                                        path: '/user_gl',//
                                    }
                                ],
                            },
                            {
                                title: '其他',
                                list: [
                                    {
                                        title: '帮助中心',
                                        images1: require('../../assets/img/user_info/user_index/bzzx1.png'),
                                        images2: require('../../assets/img/user_info/user_index/bzzx2.png'),
                                        path: '/user_bzzx',//
                                    }
                                ],
                            }
                        ]
                    }
                    //    this.user_info=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },



    },

}
</script>
<style scoped lang="less">
.user_index {
    width: 100%;
    // height: 680px;
    background-color: #F5F5F5;
    padding: 21px;
    padding-bottom: 100px;

    .user_index_box {
        width: 1440px;
        margin: auto;

        .title_box {
            padding-bottom: 21px;

            display: flex;
            align-items: center;

            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;

            .span1 {
                cursor: pointer;
                margin-right: 10px;
            }

            .span2 {
                cursor: pointer;
                margin-left: 10px;
            }

            img {
                margin-right: 10px;
                width: 14px;
            }
        }

        .index_flex {
            display: flex;
            align-content: end;
            justify-content: space-between;

            .lefts {
                width: 220px;
                min-height: 700px;
                background: #FFFFFF;
                border-radius: 0px 0px 0px 0px;
                padding: 16px 0;

                .item_title {
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #8C959E;
                    margin-bottom: 8px;
                    padding: 0 24px;
                }

                .item_list {
                    padding-bottom: 20px;

                    .item_item {
                        padding: 0 24px;
                        width: 220px;
                        height: 36px;
                        // background: #377CFD;
                        // border-radius: 0px 0px 0px 0px;
                        // opacity: 0.04;
                        position: relative;
                        cursor: pointer;
                        display: flex;
                        align-items: center;

                        .item_img {
                            .img1 {
                                display: inline;
                            }

                            .img2 {
                                display: none;
                            }

                            img {
                                width: 12px;
                                // height: 14px;
                            }
                        }

                        .item_name {
                            padding-left: 10px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                        }

                        .item_bg {
                            width: 220px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 0px 0px 0px 0px;
                            opacity: 0.04;
                            position: absolute;
                            top: 0;
                            left: 0;
                            display: none;
                        }

                        .item_borders {
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: 4px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 0px 0px 0px 0px;
                            display: none;

                        }

                        &:hover {
                            color: #377CFD;

                            .item_img {
                                .img1 {
                                    display: none;
                                }

                                .img2 {
                                    display: inline;
                                }
                            }

                            .item_bg {
                                display: inline;
                            }

                            .item_borders {
                                display: inline;
                            }
                        }


                    }

                    .item_item_ac {
                        color: #377CFD;

                        .item_img {
                            .img1 {
                                display: none;
                            }

                            .img2 {
                                display: inline;
                            }
                        }

                        .item_bg {
                            display: inline;
                        }

                        .item_borders {
                            display: inline;
                        }
                    }
                }

            }

            .rights {
                width: 1196px;
                // height: 100px;
                // background-color: red;
            }

        }

    }
}
</style>